import { useTranslations } from '@vocab/react';
import {
  Stack,
  Card,
  Text,
  Box,
  IconTip,
  Badge,
  List,
  Inline,
} from 'braid-design-system';

import translations from '../.vocab';

export const BadgeGuide = () => {
  const { t } = useTranslations(translations);

  return (
    <Card rounded>
      <Box width="full" paddingBottom="small">
        <Stack space="large">
          <Inline space="small" alignY="center">
            <IconTip size="large" />
            <Text size="small" weight="strong">
              {t('whenSeeTheBadge')}
            </Text>
          </Inline>

          <Stack space="small">
            <Badge tone="promote" weight="regular">
              {t('APACIntegration')}
            </Badge>
            <List>
              <Text tone="secondary">{t('connectedPartnerSupportAPAC')}</Text>
            </List>
          </Stack>

          <Stack space="small">
            <Badge tone="info" weight="regular">
              {t('middlewareRequired')}
            </Badge>
            <List>
              <Text tone="secondary">
                {t('MiddlewareIsRequiredTalkToPartner')}
              </Text>
            </List>
          </Stack>
        </Stack>
      </Box>
    </Card>
  );
};
